import { LeadStatus } from './types';

export const COLUNAS_LEADS: LeadStatus[] = [
  'novo',
  'contato_iniciado',
  'contato_estabelecido',
  'em_qualificacao',
  'qualificado',
];

export const STATUS_LEAD_LABELS: Record<LeadStatus, string> = {
  novo: 'Novo',
  contato_iniciado: 'Contato iniciado',
  contato_estabelecido: 'Contato estabelecido',
  em_qualificacao: 'Em qualificação',
  qualificado: 'Qualificado',
  convertido: 'Convertido',
  descartado: 'Descartado',
};

export const STATUS_LEAD_CORES: Record<LeadStatus, { cor: string; fundo: string }> = {
  novo: { cor: '#1677FF', fundo: '#EAF3FF' },
  contato_iniciado: { cor: '#722ED1', fundo: '#F5EDFF' },
  contato_estabelecido: { cor: '#08979C', fundo: '#E6FFFB' },
  em_qualificacao: { cor: '#D48806', fundo: '#FFF7E6' },
  qualificado: { cor: '#389E0D', fundo: '#F0FFE8' },
  convertido: { cor: '#237804', fundo: '#F6FFED' },
  descartado: { cor: '#8C8C8C', fundo: '#F5F5F5' },
};

export const CANAIS_LEAD = [
  { value: 'indicacao_interna', label: 'Indicação interna' },
  { value: 'carteira', label: 'Carteira' },
  { value: 'prospeccao_ativa', label: 'Prospecção ativa' },
  { value: 'inbound', label: 'Inbound' },
  { value: 'rede_socio', label: 'Rede do sócio' },
  { value: 'licitacao_publica', label: 'Licitação pública' },
  { value: 'parceiro', label: 'Parceiro' },
];

export function canalLabel(valor: string | null): string | null {
  return CANAIS_LEAD.find(c => c.value === valor)?.label || valor;
}

export function extrairDadosApi(resposta: any): any {
  const bruto = resposta?.data ?? resposta;
  if (bruto?.body) {
    try { return JSON.parse(bruto.body); } catch { return bruto.body; }
  }
  return bruto;
}

export function mensagemErroApi(erro: any): string {
  const dado = extrairDadosApi(erro?.response);
  const mensagem = dado?.error || dado?.erro || erro?.message || 'Erro inesperado';
  return typeof mensagem === 'string' ? mensagem : mensagem?.error || JSON.stringify(mensagem);
}

export function situacaoProximoContato(data: string | null): {
  label: string;
  cor: 'red' | 'gold' | 'blue';
} | null {
  if (!data) return null;
  const hoje = new Date();
  hoje.setHours(0, 0, 0, 0);
  const alvo = new Date(`${data.slice(0, 10)}T00:00:00`);
  const dias = Math.round((alvo.getTime() - hoje.getTime()) / 86400000);
  if (dias < 0) return { label: `${Math.abs(dias)}d atrasado`, cor: 'red' };
  if (dias === 0) return { label: 'Contato hoje', cor: 'gold' };
  if (dias === 1) return { label: 'Contato amanhã', cor: 'blue' };
  return { label: `Contato em ${dias}d`, cor: 'blue' };
}
